// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QkNcp","field":"styles_field__g4YhF","fieldCol":"styles_fieldCol__3KZaa","diffCol":"styles_diffCol__2ugSN","diff":"styles_diff__1jvET"};